export default "/_next/static/fonts/Caveat.419940188ab4de524042a7fb202f266b.ttf";